/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Station_Readiness_Blocked_Without_Request_IdInputs */

const vi_station_readiness_blocked_without_request_id = /** @type {(inputs: Station_Readiness_Blocked_Without_Request_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máy trạm chưa được giám sát từ ${i?.time} — đăng nhập lại hoặc báo quản trị.`)
};

/**

* @param {Station_Readiness_Blocked_Without_Request_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_readiness_blocked_without_request_id = /** @type {((inputs: Station_Readiness_Blocked_Without_Request_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Readiness_Blocked_Without_Request_IdInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_readiness_blocked_without_request_id(inputs)
});